import { render, staticRenderFns } from "./interviewCandidateText.vue?vue&type=template&id=67b5a842&scoped=true"
import script from "./interviewCandidateText.vue?vue&type=script&lang=js"
export * from "./interviewCandidateText.vue?vue&type=script&lang=js"
import style0 from "./interviewCandidateText.vue?vue&type=style&index=0&id=67b5a842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5a842",
  null
  
)

export default component.exports